import React, { lazy } from 'react';
import { Route } from 'react-router-dom';
import EPage from '@/enums/EPages';
import { PrivateRoute } from '@/hooks/useAuth';
import EBasicActions from '@/enums/EBasicActions';

const MembershipControlPage = lazy(() => import('@/containers/Views/MembershipControl/MembershipControlPage'));

const MembershipControlRouter = (
  <Route path="membership_control">
    <Route
      index 
      element={(
        <PrivateRoute 
          pageName={EPage.MembershipControl} 
          permissions={EBasicActions.Find}
        >
          <MembershipControlPage />
        </PrivateRoute>
      )} 
    />
  </Route>
);

export default MembershipControlRouter;
